import { AppState } from '../types/AppState';
import { SystemGroupOrderConfigurator } from '../types/SystemGroupOrderConfigurator';

export const getSystemGroupOrderConfigurators = (appState: AppState): SystemGroupOrderConfigurator[] | undefined =>
  appState.systemGroupOrderConfigurators.systemGroupOrderConfigurators;
